import React from "react";
import '../styles/selectorPabellon.css';

const pabellones = [
  { nombre: "Verde", id: "verde" },
  { nombre: "Amarillo", id: "amarillo" },
  { nombre: "Azul", id: "azul" },
  { nombre: "Blanco", id: "blanco" },
  { nombre: "Rojo", id: "rojo" },
];

function SelectorPabellon({ pabellonSeleccionado, setPabellonSeleccionado }) {
  return (
    <div className="selector-pabellon">
      <h2>Selecciona un pabellón:
      </h2>
      <div className="botones-pabellones">
        {pabellones.map((pabellon) => (
          <button
            key={pabellon.id}
            className={
              pabellonSeleccionado === pabellon.id ? "activo" : ""
            }
            onClick={() => setPabellonSeleccionado(pabellon.id)}
          >
            {pabellon.nombre}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SelectorPabellon;
